const initialState = {
  remoteControlSessionStatus: [],
  remoteSupportSessionStatus: [],
  wakeOnLanStatusArr: [],
  powerOptionsStatusArr: []
};

export default function filtersReducer(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_REMOTE_CONTROL_SESSION_STATUS':
      return { ...state, remoteControlSessionStatus: action.data.remoteControlSessionStatus };

    case 'UPDATE_REMOTE_SUPPORT_SESSION_STATUS':
      return { ...state, remoteSupportSessionStatus: action.data.remoteSupportSessionStatus };  

    case 'UPDATE_WAKE_ON_LAN_STATUS':
      return { ...state, wakeOnLanStatusArr: action.data.wakeOnLanStatusArr };

    case 'UPDATE_POWER_OPTIONS_STATUS':
      return { ...state, powerOptionsStatusArr: action.data.powerOptionsStatusArr };

    default:
      return state;
  }
}

function upsertStatus(arr, matchFn, newItem) {
  const index = arr.findIndex(matchFn);
  if (index !== -1) {
    const updated = [...arr];
    updated[index] = newItem;
    return updated;
  }
  return [...arr, newItem];
}

export function updateRemoteControlSessionStatus(deviceId, sessionStatus) {
  const store = window.store;
  if (!store) return;

  const currentStatus = store.getState().remote.remoteControlSessionStatus;
  const deviceStatus = { deviceId: parseInt(deviceId), status: sessionStatus };

  const newArr = upsertStatus(currentStatus, obj => obj.deviceId === deviceStatus.deviceId, deviceStatus);

  store.dispatch({
    type: 'UPDATE_REMOTE_CONTROL_SESSION_STATUS',
    data: { remoteControlSessionStatus: newArr }
  });
}

export function updateRemoteSupportSessionStatus(sessionId, sessionStatus) {
  const store = window.store;
  if (!store) return;

  const currentStatus = store.getState().remote.remoteSupportSessionStatus;
  const newSessionStatus = { sessionId: parseInt(sessionId), status: sessionStatus };

  const newArr = upsertStatus(currentStatus, obj => obj.sessionId == newSessionStatus.sessionId, newSessionStatus);

  store.dispatch({
    type: 'UPDATE_REMOTE_SUPPORT_SESSION_STATUS',
    data: { remoteSupportSessionStatus: newArr }
  });
}

export function updateWakeOnLanStatus(deviceId, status, remarks) {
  const store = window.store;
  if (!store) return;

  const currentStatus = store.getState().remote.wakeOnLanStatusArr;
  const wakeOnLanStatus = { deviceId: parseInt(deviceId), status, remarks };

  const newArr = upsertStatus(currentStatus, obj => obj.deviceId === wakeOnLanStatus.deviceId, wakeOnLanStatus);

  store.dispatch({
    type: 'UPDATE_WAKE_ON_LAN_STATUS',
    data: { wakeOnLanStatusArr: newArr }
  });
}

export function updatePowerOptionsStatus(deviceId, powerOption, status, remarks) {
  const store = window.store;
  if (!store) return;

  const currentStatus = store.getState().remote.powerOptionsStatusArr;
  const powerOptionsStatus = { deviceId: parseInt(deviceId), powerOption, status, remarks };

  const newArr = upsertStatus(currentStatus, obj => obj.deviceId === powerOptionsStatus.deviceId, powerOptionsStatus);

  store.dispatch({
    type: 'UPDATE_POWER_OPTIONS_STATUS',
    data: { powerOptionsStatusArr: newArr }
  });
}
